import { Typography } from "@mui/material"
import { useEffect, useRef, useState } from "react"
import { RightDrawer } from "lib/@components/drawer/right-drawer"
import { Bound } from "lib/@components/binding/Bound"
import { ShowActivity } from "routes/@lib/activity/activity.runtime"
import { If } from "lib/@components/switch"
import { AuditContainer } from "./container"
import { useLocation } from "react-router-dom"

export function ActivityDrawer() {
    const [auditLogData, setAuditLogData] = useState({})
    const { data, forTypeAllClients, type, id, fileNamePrefix, filterFn, filter, pageSize } = auditLogData
    const location = useLocation()
    const previousLocation = useRef(location.key)

    ShowActivity.useEvent((values) => {
        setAuditLogData(values)
    })

    useEffect(() => {
        if (previousLocation.current === location.key) return
        previousLocation.current = location.key
        setAuditLogData({})
    }, [location.key])

    return (
        <RightDrawer
            open={!!id}
            setOpen={setOpen}
            onClose={setOpen}
            dialogActions={
                <AuditContainer
                    setOpen={setOpen}
                    type={type}
                    fileNamePrefix={fileNamePrefix}
                    filterFn={filterFn}
                    id={id}
                    auditLogData={auditLogData}
                    isDialog={true}
                    filter={filter}
                    pageSize={pageSize}
                />
            }
        >
            <Typography variant={"h5"} mb={1}>
                Activity
            </Typography>
            <If truthy={id}>
                <Bound auditId={id} type={type} refresh={data}>
                    <AuditContainer
                        setOpen={setOpen}
                        type={type}
                        id={id}
                        forTypeAllClients={forTypeAllClients}
                        fileNamePrefix={fileNamePrefix}
                        filterFn={filterFn}
                        auditLogData={auditLogData}
                        filter={filter}
                        pageSize={pageSize}
                    />
                </Bound>
            </If>
        </RightDrawer>
    )

    function setOpen(value) {
        if (!value) {
            setAuditLogData({})
        }
    }
}
